__turbopack_context__.v({
  "arrow": "dropdown-module-sass-module__BzLjsG__arrow",
  "dropdown": "dropdown-module-sass-module__BzLjsG__dropdown",
  "dropdownContainer": "dropdown-module-sass-module__BzLjsG__dropdownContainer",
  "error": "dropdown-module-sass-module__BzLjsG__error" + " " + __turbopack_context__.i(348263)["error"],
  "fieldError": "dropdown-module-sass-module__BzLjsG__fieldError",
});
